import React from 'react'

//Styles
import Styles from './nama-debitur.module.scss'

//Components
import TextMedium from 'pages/dashboard/e-reporting/forms/components/reuseables/text-medium'
import WrapperAndBox from 'pages/dashboard/e-reporting/forms/components/reuseables/wrapper-and-box/WrapperAndBox'
import ButtonSelanjutnya from 'pages/dashboard/e-reporting/forms/components/reuseables/button-selanjutnya/ButtonSelanjutnya'
import InputText from 'pages/dashboard/e-reporting/forms/components/reuseables/input-text'
import ButtonSebelumnya from 'pages/dashboard/e-reporting/forms/components/reuseables/button-sebelumnya'
import BoxFlex from 'pages/dashboard/e-reporting/forms/components/reuseables/box-flex'

//Hooks
import { STEPS, useFormMethod, useFormState } from "pages/dashboard/e-reporting/forms/context";

function NamaDebitur() {
  //Context
  const { setCurrentStep, formHandler, handlePrevState } = useFormMethod();
  const { isAprroval, form } = useFormState()

  //State
  const [value, setValue] = React.useState(form.debtor_name.value ?? '')

  const onNext = () => {
    handlePrevState()
    formHandler('debtor_name', value)
    setCurrentStep(STEPS.teleponDebitur)
  }
  return (
    <WrapperAndBox>
      <div className={Styles['title']}>
        <TextMedium required>
          Nama Debitur
        </TextMedium>
      </div>

      <div className={Styles['input-wrapper']}>
        <InputText 
          value={value} 
          disabled={isAprroval} 
          onChange={(e) => setValue(e.target.value || '')} 
          placeholder="Masukkan nama lengkap debitur" 
        />
        <BoxFlex>
          <>
            <ButtonSebelumnya />
            {!!value && <ButtonSelanjutnya onClick={onNext} />}
          </>
        </BoxFlex>
      </div>
    </WrapperAndBox>
  )
}

export default NamaDebitur